import { duration } from 'moment';
import { EMOJI_REGEX } from '../../utils/emoji-regex';

import { postUserFavorite, postHiringProcessChecked, postProccessUpdate } from './ajax.js';
import { countingAnimation } from '@/animation';
import { easing } from 'jquery';


/*
  turbolinks:load
*/
$(window).on('turbolinks:load', function () {
  for (const scrollBottom of document.querySelectorAll('.js-onloadScrollBottom')) {
    if (scrollBottom.tagName === 'BODY') {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight)
      }, 200);
    }
  }

  // 【企業】チャットボタンの一定期間非表示機能

  // Cookie操作のヘルパー関数
  function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  if ($('.js-chat-button').length) {
    const chatButton = $('.js-chat-button');
    const hiddenUntilKey = 'ciy_chat_button_hidden_until';

    // クローズボタンクリック時：24時間非表示に設定
    $('.js-close-chat-button').on('click', (e) => {
      const hiddenUntilTime = new Date();
      hiddenUntilTime.setHours(hiddenUntilTime.getHours() + 24); // 24時間後まで非表示
      setCookie(hiddenUntilKey, hiddenUntilTime.toISOString(), 24);
      if (!chatButton.hasClass('is-minified')) {
        chatButton.addClass('is-minified');
      }
    });
    $('.js-show-chat-button').on('click', (e) => {
      setCookie(hiddenUntilKey, '', 0);
      if (chatButton.hasClass('is-minified')) {
        chatButton.removeClass('is-minified');
      }
    });
  }

  //【共通】お気に入りボタン
  if ($('.favorite-btn').length) {
    $('.favorite-btn').click(function () {
      //モーダルの表示
      var user_id = $(this).data('user-id');
      var recruit_id = $(this).data('recruit-id');
      var hadFavorite = $(this).hasClass('act');
      if (user_id) {
        postUserFavorite(user_id, recruit_id, hadFavorite).then((res) => {
          $(this).toggleClass('act');
        });
      }
    });
  }

  //【共通】お問い合わせフォームの確認モーダル
  if ($('.confirm-contact-form').length) {
    const contactCategoriesPerson = [
      'この仕事についての質問',
      '企業訪問、説明会の参加希望',
      'インターンについて / インターン希望',
      '応募について',
    ];
    const contactCategoriesCompany = [
      '大学での専攻・研究内容についての質問',
      '企業訪問・説明会などへの招待',
      'これまでの職歴・経歴に関する質問',
      'その他',
    ];
    $('.confirm-contact-form').click(function (e) {
      e.preventDefault();
      err_cnt = 0;
      $(this)
        .parents('form')
        .find('.validate-flag')
        .each(function () {
          err_cnt += front_varidation(this);
        });
      var $form = $('form[name="contact_form"]');
      var category = $form.find('input[name="contact[category]"]:checked').val();
      var content = $form.find('textarea[name="contact[content]"]').val();
      if (err_cnt == 0) {
        var $modal = $('.modal-wrap[data-modal="message"]');
        $modal.find('#contact-category-person').text(contactCategoriesPerson[category - 1]);
        $modal.find('#contact-category-company').text(contactCategoriesCompany[category - 1]);
        $modal.find('#contact-content').text(content);

        $modal.fadeIn(200);
      }
    });
  }

  //【共通】エントリーフォームの確認モーダル
  if ($('.confirm-entry-form').length) {
    $('.confirm-entry-form').click(function (e) {
      e.preventDefault();
      err_cnt = 0;
      $('form[name="entry_form"]')
        .find('.validate-flag')
        .each(function () {
          err_cnt += front_varidation(this);
        });
      var $form = $('form[name="entry_form"]');
      if (err_cnt == 0) {
        var $modal = $('.modal-wrap[data-modal="entry"]');
        $modal.find('#entry-content').text($form.find('textarea[name="contact[content]"]').val());
        $modal.fadeIn(200);
      }
    });
  }

  //【共通】数値を兆億万の表記に変換する
  if ($('.add-numeral').length) {
    console.log('num');
    $('.add-numeral').each(function () {
      var targetNum = $(this).text() + '000';
      var num = targetNum;
      var keta = ['', '万', '億', '兆'];
      var nums = String(num)
        .replace(/(\d)(?=(\d\d\d\d)+$)/g, '$1,')
        .split(',')
        .reverse();
      var data = '';
      for (var i = 0; i < nums.length; i++) {
        if (!nums[i].match(/^[0]+$/)) {
          data = nums[i].replace(/^[0]+/g, '') + keta[i] + data;
        }
      }
      $(this).text(data);
    });
  }

  //【共通】質問箱に入力があった場合にクラス付与
  if ($('.question-box').length) {
    $('.question-box textarea').keyup(function () {
      var input = $(this).val();
      console.log(input);
      if (input != false) {
        $(this).parents('.question-box').addClass('-answered');
      } else {
        $(this).parents('.question-box').removeClass('-answered');
      }
    });
  }

  //【共通】チャートのレスポンシブ化
  $.fn.responsiveTable = (function () {
    var $window = $(window);
    return function () {
      var $el = $(this).parent('.responsive-table');
      var $table = this;
      var onResize = function () {
        var width = $table.outerWidth();
        var height = $table.outerHeight();
        var $parent = $el.parent();
        var containerWidth = $parent.width();
        var ratio = containerWidth / width;
        if (ratio < 1) {
          $el.height(height * ratio);
          $table.css('transform', 'scale(' + ratio + ')');
        } else {
          $el.height('');
          $table.css('transform', '');
        }
      };
      $table.css('transformOrigin', '0 0');
      $window.on('resize', onResize);
      onResize();
    };
  })();
  if ($('body.js-responsiveTable-target').length) {
    $('.resultChart').each(function (index) {
      $(this).wrap('<div class="responsive-table">');
      $(this).responsiveTable();
    });
  }
  if ($('body.js-linechart-target').length) {
    var target = '.resultChart-competency-company';
    var skills;
    var val;
    skills = $(target).data('chart');
    for (var k = 0; k < skills.length; k++) {
      val = 100 - skills[k];
      if (val < 20) {
        val = 0;
      } else if (val < 40) {
        val = 1;
      } else if (val < 48) {
        val = 2;
      } else if (val < 52) {
        val = 3;
      } else if (val < 60) {
        val = 4;
      } else if (val < 80) {
        val = 5;
      } else if (val <= 100) {
        val = 6;
      }
      val = val * 32;
      $(target)
        .find('.chart-circle-company:eq(' + k + ')')
        .attr('cx', val);
      $(target)
        .find('.chart-line-company:eq(' + k + ')')
        .attr('x1', val);
      $(target)
        .find('.chart-line-company:eq(' + (k - 1) + ')')
        .attr('x2', val);
    }
    var target = '.resultChart-competency-person';
    var skills;
    var val;
    skills = $(target).data('chart');
    for (var k = 0; k < skills.length; k++) {
      val = 100 - skills[k];
      if (val < 20) {
        val = 0;
      } else if (val < 40) {
        val = 1;
      } else if (val < 48) {
        val = 2;
      } else if (val < 52) {
        val = 3;
      } else if (val < 60) {
        val = 4;
      } else if (val < 80) {
        val = 5;
      } else if (val <= 100) {
        val = 6;
      }
      val = val * 32;
      $(target)
        .find('.chart-circle-person:eq(' + k + ')')
        .attr('cx', val);
      $(target)
        .find('.chart-line-person:eq(' + k + ')')
        .attr('x1', val);
      $(target)
        .find('.chart-line-person:eq(' + (k - 1) + ')')
        .attr('x2', val);
    }
  }
  //レーダーチャート
  if ($('body.js-radarchart-target').length) {
    var target = '.resultChart-strengths-company';
    var allPentagonPoints = [];
    var skills;
    skills = $(target).data('chart');
    drawChartFoundation(target);
    //polygon要素を生成
    var chartPolygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    var chartPolygonPoint = ''; //各点の座標
    //chartPolygonの座標を設定
    for (var k = 0; k < skills.length; k++) {
      var levelNum = parseInt(10 - skills[k] / 10);
      var selectedPoint = allPentagonPoints[levelNum].split(' ')[k].split(',');
      chartPolygonPoint += selectedPoint[0] + ',' + selectedPoint[1] + ' ';
      $(target)
        .find('.chart-edgepoint-company:eq(' + k + ')')
        .attr('cx', selectedPoint[0])
        .attr('cy', selectedPoint[1]);
    }
    chartPolygon.setAttribute('points', chartPolygonPoint);
    chartPolygon.setAttribute('class', 'status');
    $(target).find('.chart_Polygon').append(chartPolygon);

    //（求職者）
    var target = '.resultChart-strengths-person';
    var allPentagonPoints = [];
    var skills;
    skills = $(target).data('chart');
    drawChartFoundation(target);
    //五角形を生成
    //polygon要素を生成
    var chartPolygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
    var chartPolygonPoint = ''; //各点の座標
    //chartPolygonの座標を設定
    for (var k = 0; k < skills.length; k++) {
      var levelNum = parseInt(10 - skills[k] / 10);
      var selectedPoint = allPentagonPoints[levelNum].split(' ')[k].split(',');
      chartPolygonPoint += selectedPoint[0] + ',' + selectedPoint[1] + ' ';
      $(target)
        .find('.chart-edgepoint-person:eq(' + k + ')')
        .attr('cx', selectedPoint[0])
        .attr('cy', selectedPoint[1]);
    }
    chartPolygon.setAttribute('points', chartPolygonPoint);
    chartPolygon.setAttribute('class', 'status');
    $(target).find('.chart_Polygon').append(chartPolygon);

    function createPentagons(dis) {
      //polygon要素を生成
      var Pentagon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
      var pentagonPoints = '';
      for (var i = 0; i < 5; i++) {
        var x = Math.cos(((72 * i - 90) * Math.PI) / 180) * dis;
        var y = Math.sin(((72 * i - 90) * Math.PI) / 180) * dis;
        pentagonPoints += x + 150 + ',' + (y + 150) + ' ';
      }
      allPentagonPoints.push(pentagonPoints);
      //座標を設定
      Pentagon.setAttribute('points', pentagonPoints);
      return Pentagon;
    }
    //生成した五角形を表示＋プロットした点を表示
    function drawChartFoundation(where) {
      //中心からの距離ごとに五角形をつくる
      var distance = [150, 135, 120, 105, 90, 75, 60, 45, 30, 15, 1];
      for (var i = 0; i < distance.length; i++) {
        createPentagons(distance[i]);
      }
    }
  }

  //【共通】URLなどコピーするボタン
  var clipboard = new ClipboardJS('.js-clipboard-copy');
  clipboard.on('success', (e) => {
    const title = e.trigger.dataset.clipboardTitle;
    alert(title + 'をコピーしました');
  });

  //【共通】モーダル系の記述
    if ($('.modal-wrap').length) {
      $(document).on('click', '.modal-tgl', function () {
        //モーダルの表示
        var modal = $(this).data('modal');
        $('.modal-wrap[data-modal="' + modal + '"]').fadeIn(200);
      });
      $(document).on('click', '.modal-wrap .modal-close', function () {
        //モーダルの非表示
        $('.modal-wrap').fadeOut(200);
      });
      $(document).on('click', '.modal-wrap .modal-close-onlyParent', function () {
        //モーダルの非表示
        $(this).parents('.modal-wrap').fadeOut(200);
      });
    }
  //【共通】スライドモーダル系の記述
  if ($('.slide-modal').length) {
    $('.slide-modal-tgl').on('click', function () {
      //モーダルの表示
      if (!$(this).hasClass('c-key')) {
        var modal = $(this).data('modal');
        $('.slide-modal-tgl').removeClass('c-key bdc-key');
        $(this).addClass('c-key bdc-key');
        $('.slide-modal').removeClass('act');
        $('.slide-modal[data-modal="' + modal + '"]').addClass('act');
      } else {
        $(this).removeClass('c-key bdc-key');
        $('.slide-modal').removeClass('act');
      }
    });
    $('.slide-modal .modal-close').on('click', function () {
      //モーダルの非表示
      $('.slide-modal').removeClass('act');
      $('.slide-modal-tgl').removeClass('c-key bdc-key');
    });
  }

  //【共通】スムーススクロール
  $('a[href^="#"]').on('click', function () {
    var H = $('header').outerHeight();
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - H;
    var speed = 500;
    $('html, body').animate(
      {
        scrollTop: position,
      },
      speed,
      'swing'
    );
    return false;
  });

  //【共通】全角数字が入力されたら半角に変換するコード
  //数字と.（ドット）のみ入力許可
  $('input[type="tel"].num-only').on('input', function (e) {
    let value = $(e.currentTarget).val();
    value = value
      .replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      })
      .replace(/．/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      })
      .replace(/[^0-9\.]/g, '');
    $(e.currentTarget).val(value);
  });

  //【共通】絵文字が入力されたら削除
  $('input[type!="file"], textarea').on('input', function (e) {
    const replaceValue = $(this).val().replace(EMOJI_REGEX, '');
    $(this).val(replaceValue);
  });

  //【共通】トグルパーツの動き
  $(document).off('click', '.dd-tgl');
  $(document).on('click', '.dd-tgl', function () {
    $(this).next('.dd-body').slideToggle('fast').toggleClass('act');
    $(this).toggleClass('act');
  });
  $(document).off('click', '.dd-tgl + .dd-body .close-btn');
  $(document).on('click', '.dd-tgl + .dd-body .close-btn', function () {
    $(this).parent('.dd-body').slideUp(200).removeClass('act');
    $(this).parent('.dd-body').prev('.dd-tgl').removeClass('act');
  });
  //【共通】トグルパーツの動き（フェード版）
  $(document).off('click', '.dd-tgl-fade');
  $(document).on('click', '.dd-tgl-fade', function () {
    $(this).next('.dd-body').fadeToggle(200).toggleClass('act');
    $(this).toggleClass('act');
  });
  $(document).off('click', '.dd-tgl-fade + .dd-body .close-btn');
  $(document).on('click', '.dd-tgl-fade + .dd-body .close-btn', function () {
    $(this).parent('.dd-body').fadeOut('fast').removeClass('act');
    $(this).parent('.dd-body').prev('.dd-tgl').removeClass('act');
  });

  //【共通】サブナビゲーションのアクティブなリンクを画面内に誘導
  if ($('.nav-sub').length) {
    var slide_w = $('.nav-sub ul').find('li.act').offset().left;
    $('.nav-sub ul').animate(
      {
        scrollLeft: slide_w,
      },
      1
    );
  }

  //【共通】生年月日入力時のフォーカス自動繊維
  if ($('body#totem-birth, #c-directly-profile').length) {
    $('.cardnumber.-year').bind('keyup', function () {
      var thisValueLength = $(this).val().length;
      if (thisValueLength == 4) {
        $('.cardnumber.-month').focus();
      }
    });
    $('.cardnumber.-month').bind('keyup', function () {
      var thisValueLength = $(this).val().length;
      if (thisValueLength == 2) {
        $('.cardnumber.-day').focus();
      }
    });
  }

  // 【共通】親子チェックボックス
  $('.p-cat').on('click', function () {
    $(this).parents('.p-cat-wrap').find('.c-cat').prop('checked', this.checked);
  });
  $('.c-cat').on('click', function () {
    if (
      $(this).parents('.p-cat-wrap').find('.c-cat:checked').length ==
      $(this).parents('.p-cat-wrap').find('.c-cat').length
    ) {
      $(this).parents('.p-cat-wrap').find('.p-cat').prop('checked', 'checked');
    } else {
      $(this).parents('.p-cat-wrap').find('.p-cat').prop('checked', false);
    }
  });

  /* 【共通】URLを入れる項目に、「http」が入ってなかったときに「http://」を入れる
  -------------------------------*/
  if ($('.js-urlCheck').length) {
    $('.js-urlCheck').each(function () {
      var url = $(this).attr('href');
      if (url.indexOf('http') !== 0 && url.indexOf('//') !== 0) {
        url = 'http://' + url;
        console.log(url);
        $(this).attr('href', url);
      }
    });
  }

  //【共通】トーテム診断
  {
    /* 関数：次のカードが出現 */
    function card_answer(card) {
      //このカード
      $(card).parents('.card').removeClass('-current').addClass('-answered');
      //この前以前のカード
      $(card).parents('.card').prev('.card').removeClass('-answered').addClass('-hide');
      //この次以降のカード
      $(card)
        .parents('.card')
        .next('.card')
        .removeClass('-unanswered')
        .addClass('-current')
        .next('.card')
        .removeClass('-hide')
        .addClass('-unanswered');
    }
    /* 関数：前のカードに戻る */
    function card_back(card) {
      //このカード
      $(card).parents('.card').removeClass('-answered').addClass('-current');
      //この前以前のカード
      $(card).parents('.card').prev('.card').removeClass('-hide').addClass('-answered');
      //この次以降のカード
      $(card)
        .parents('.card')
        .next('.card')
        .removeClass('-current')
        .addClass('-unanswered')
        .next('.card')
        .removeClass('-unanswered')
        .addClass('-hide');
    }
    /* 非言語診断E, I, G, H, J, C, B, K, L */
    /* タップしたら次へ */
    $('.form-flame')
      .find(
        '.card.-question-e, .card.-question-i, .card.-question-g, .card.-question-h, .card.-question-j, .card.-question-b, .card.-question-k, .card.-question-l, .card.-question-m, .card.-question-n, .card.-question-o, .card.-question-p'
      )
      .find('.answers input')
      .change(function () {
        card_answer(this);
      });
    /* 「1つ前の設問へ」でカードの選択を取り消す */
    $('.form-flame')
      .find(
        '.card.-question-e, .card.-question-i, .card.-question-g, .card.-question-h, .card.-question-j, .card.-question-c, .card.-question-b, .card.-question-k, .card.-question-l, .card.-question-m, .card.-question-n, .card.-question-o, .card.-question-p'
      )
      .find('.card-back')
      .click(function () {
        $(this).parents('.card').find('input').prop('checked', false);
        card_back(this);
      });
    /* 「1つ前の設問へ」でチェックをつけ直す */
    $('.form-flame')
      .find('.card.-question-d2')
      .find('.card-back')
      .click(function () {
        $(this).parents('.card').find('input').prop('checked', true);
        card_back(this);
      });
    /* 非言語診断F */
    let arr = [];
    /* タップしたら配列にカスタム属性を追加・削除して数字を表示 */
    $('.form-flame')
      .find('.card.-question-f, .card.-question-d, .card.-question-q')
      .find('.answers input')
      .change(function () {
        var type = $(this).parent('label').data('type');
        if (arr.indexOf(type) != -1) {
          //含む場合の処理
          var idx = arr.indexOf(type);
          if (idx >= 0) {
            arr.splice(idx, 1);
          }
          $('.card.-current label .selected-num').text('');
        } else {
          //含まない場合の処理
          arr.push(type); //配列に追加する
        }
        $.each(arr, function (index, value) {
          $('.card.-current label[data-type="' + value + '"] .selected-num').text(index + 1);
        });
      });
    /* 全て選択したら.cardのclassによって各動作を実行 */
    $('.form-flame')
      .find('.card.-question-f, .card.-question-d, .card.-question-q')
      .find('.answers input')
      .change(function () {
        var input_count = $('.card.-current input').length;
        var check_count = $('.card.-current input:checked').length;
        /* 全て選択したら次へ */
        if ($(this).parents('.card').hasClass('-question-f')) {
          if (input_count == check_count) {
            arr = [];
            card_answer(this);
          }
          /* 全て選択したら「次へ」ボタンがアクティブ */
        } else if ($(this).parents('.card').hasClass('-question-d')) {
          if (input_count == check_count) {
            $(this).parents('.card').find('.next-card').removeClass('no-active');
          } else {
            $(this).parents('.card').find('.next-card').addClass('no-active');
          }
        } else if ($(this).parents('.card').hasClass('-question-q')) {
          setTimeout(() => {
            if (input_count == check_count) {
              arr = [];
              card_answer(this);
            }
          }, 300);
        }
      });
    /* 「次へ」ボタンで次へ */
    $('.form-flame')
      .find('.card')
      .find('.next-card')
      .click(function () {
        arr = [];
        card_answer(this);
      });
    /* 「1つ前の設問へ」でカードの選択を取り消す */
    $('.form-flame')
      .find('.card.-question-f, .card.-question-d, .card.-question-q')
      .find('.card-back')
      .click(function () {
        $(this).parents('.card').find('input').prop('checked', false);
        $(this).parents('.card').find('.selected-num').text('');
        arr = [];
        card_back(this);
        if (
          $(this).parents('.card').hasClass('-question-d') ||
          $(this).parents('.card').hasClass('-question-q')
        ) {
          $(this).parents('.card').find('.next-card').addClass('no-active');
        }
      });
    /* 複数選択中に「1つ前の設問へ」をタップした場合は配列を空にしてカードの選択を取り消す */
    $('.form-flame .card .card-back').click(function () {
      var this_is = this;
      if (
        $(this_is).parents('.card').next('.card').hasClass('-question-f') ||
        $(this_is).parents('.card').next('.card').hasClass('-question-d') ||
        $(this_is).parents('.card').next('.card').hasClass('-question-q')
      ) {
        $(this_is).parents('.card').next('.card').find('input').prop('checked', false);
        $(this_is).parents('.card').find('.selected-num').text('');
        arr = [];
        if (
          $(this_is).parents('.card').next('.card').hasClass('-question-d') ||
          $(this_is).parents('.card').next('.card').hasClass('-question-q')
        ) {
          $(this_is).parents('.card').next('.card').find('.next-card').addClass('no-active');
        }
      }
    });

    /* 診断C：△を10回答でアラートが出現 */
    $('.card.-question-c input[type="radio"]').click(function () {
      var count = $('.card.-question-c .neither input[type="radio"]:checked').length;
      if (count >= 10) {
        $('.cheering-comments li').css('display', 'none');
        $('.cheering-comments')
          .find('li[data-index="question-c"]')
          .css('display', 'flex')
          .addClass('act');
        $('.card.-question-c.-current').addClass('neither-full');
        setTimeout(function () {
          $('.card.-question-c.-current').removeClass('neither-full');
        }, 300);
      } else {
        card_answer(this);
        $('.cheering-comments')
          .find('li[data-index="question-c"]')
          .css('display', 'none')
          .removeClass('act');
        $('.card').removeClass('neither-full');
      }
    });
  }

  //【共通】"http"が存在すればリンク化
  if ($('.auto-link-wrap').length) {
    $('.auto-link-wrap').each(function () {
      $(this).html(
        $(this)
          .html()
          .replace(
            /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/g,
            '<a href="$1" target="_blank" class="c-blue under-line">$1</a> '
          )
      );
    });
  }

  //【共通】バリデーション処理
  if ($('.validate-btn').length) {
    var err_cnt;
    $('.validate-btn').click(function (e) {
      err_cnt = 0;
      $(this)
        .parents('form')
        .find('.validate-flag')
        .each(function () {
          err_cnt += front_varidation(this);
        });
      //最終チェック//
      if (0 < err_cnt) {
        e.preventDefault();
      } else {
        // $(this).prop("disabled", true);
      }
    });

    /* 【共通】各入力欄の値を変えたときのバリデーション
    -------------------------------*/
    $('.validate-flag input,.validate-flag select,.validate-flag textarea').change(function () {
      $(this)
        .parents('.validate-flag')
        .each(function () {
          $(this).parents('form').find('.validate-btn').prop('disabled', false);
          front_varidation(this);
        });
    });
  }

  //【共通】ツールチップ
  if ($('.js-inline-tooltip').length) {
    //クリックしたら出現する
    $('.js-inline-tooltip').hover(function () {
      $(this).toggleClass('active').children('.inline-tooltip-modal').fadeToggle(100);
    });
    //ツールチップ以外をクリックすると非表示にする
    $(document).click(function (event) {
      if (!$(event.target).closest('.js-inline-tooltip').length) {
        $('.inline-tooltip-modal').fadeOut(100);
        $('.js-inline-tooltip').removeClass('active');
      }
    });
  }

  // 【共通】★★★★★ DOING スライドモーダル系の記述(Ver2.0でcommon.jsと重複するため独自。commonのイベント破棄後再設定)
  if ($('.slide-modal').length) {
    if ($('#c-profile-company-edit, #c-recruit-edit, c-work-recruit').length) {
      $('.slide-modal-tgl').off(); //common.jsに設定されているイベントを破棄
      $('.slide-modal-tgl').on('click', function () {
        //モーダルの表示
        if (!$(this).hasClass('act')) {
          var modal = $(this).data('modal');
          $('.slide-modal-tgl').removeClass('bgc-key bd-black100');
          $(this).addClass('bgc-key c-white');
          $('.slide-modal').removeClass('act');
          $('.slide-modal[data-modal="' + modal + '"]').addClass('act');
        } else {
          $(this).removeClass('bdc-key');
          $('.slide-modal').removeClass('act');
        }
      });
      $('.slide-modal .modal-close').on('click', function () {
        //モーダルの非表示
        $('.slide-modal').removeClass('act');
        $('.slide-modal-tgl').removeClass('bgc-key c-white');
        $('.slide-modal-tgl').addClass('bd-black100');
      });
    } else {
      $('.slide-modal-tgl').off(); //common.jsに設定されているイベントを破棄
      $('.slide-modal-tgl').on('click', function () {
        //モーダルの表示
        if (!$(this).hasClass('act')) {
          var modal = $(this).data('modal');
          $('.slide-modal-tgl').removeClass('bgc-key');
          $(this).addClass('bgc-key');
          $('.slide-modal').removeClass('act');
          $('.slide-modal[data-modal="' + modal + '"]').addClass('act');
        } else {
          $(this).removeClass('bdc-key');
          $('.slide-modal').removeClass('act');
        }
      });
      $('.slide-modal .modal-close').on('click', function () {
        //モーダルの非表示
        $('.slide-modal').removeClass('act');
        $('.slide-modal-tgl').removeClass('bgc-key');
      });
    }
  }

  //【企業】採用の流れ
  if ($('#c-mypage').length) {
    $('label[data-checked^=flow_]').on('change', function () {
      const isChecked = $(this).children('input[type="checkbox"]').prop('checked');
      const checkType = $(this).data('checked');
      postHiringProcessChecked(checkType, isChecked)
        .done((res) => {
          const indicator = $(`.checked-indicator > span[data-checked="${checkType}"]`);
          if (isChecked) {
            $(indicator).addClass('act');
          } else {
            $(indicator).removeClass('act');
          }
        })
        .fail(() => {
          location.reload();
        });
    });
  }

  //「求職者(応募者)に返信」ボタンを押したら実行
  $('.js-messageFocusUi-Trigger').on('click', () => {
    messageFocusUi();
  });

  //スクロールして、メッセージ送信BOXをアクティブにするモジュール
  function messageFocusUi() {
    var position = $('.js-messageFocusUi').offset().top;
    $('body,html').animate(
      {
        scrollTop: position,
      },
      300,
      'swing'
    );

    $('.js-messageFocusUi').addClass('is-active');
    $('.js-messageFocusUi input')
      .delay(400)
      .queue(function () {
        $(this).trigger('focus');
      });
  }

  //メッセージUIのフォーカス／アウトでクラスを制御
  $('.js-messageFocusUi input,.js-messageFocusUi textarea')
    .focusin(function (e) {
      $('.js-messageFocusUi').addClass('is-active');
    })
    .focusout(function (e) {
      $('.js-messageFocusUi').removeClass('is-active');
    });

  //【企業側】就業場所編集用
  if ($('.workplace-edit').length) {
    //オプション次へ(送信/保存)専用
    $('.workplace-edit').on('submit', function () {
      let renames = {
        company_workplaces: ['insert_prefecture_type', 'insert_address'],
      };
      Object.keys(renames).forEach(function (valI, idxI, aryI) {
        const key = valI;
        renames[key].forEach(function (valJ, idxJ, aryJ) {
          const elNm = "[name='" + key + '_' + valJ + "']";
          const cnt = $(elNm).length - 1;
          for (let i = 0; i < cnt; i++) {
            console.log(`key=${key}`);
            $(elNm + ':eq(0)').attr(
              'name',
              key + '[' + (i + 1) * -1 + '][' + valJ.replace('insert_', '') + ']'
            );
            console.log($(elNm + ':eq(0)'));
          }
        });
      });
    });
  }

  //企業：募集内容ページで、「雇用形態」選択の、「正社員」以外を選択すると【新卒／中途】が選択から外れる
  //企業：募集内容ページで、「雇用形態」ラジオボタンに応じて入力欄が切り替わる
  if ($('.js-recruit-type').length) {
    $('.js-intern,.js-part_time,.js-outsourcing').on('click', function () {
      $('.js-new_graduate,.js-mid_carrer').prop('checked', false);
    });
    $('.js-new_graduate,.js-mid_carrer').on('click', function () {
      $('.js-full_time').prop('checked', true);
      $('.js-typeA').fadeIn().find('textarea, input').prop('disabled', false);
      $('.js-typeB').fadeOut().find('textarea, input').prop('disabled', true);
      $('.js-typeC').fadeOut().find('textarea, input').prop('disabled', true);
    });
    typeChanger();
    $('.js-recruit-type input[type="radio"]').on('change', function () {
      typeChanger();
    });

    function typeChanger() {
      //雇用形態で「インターン」を選択
      if ($('.js-intern').prop('checked')) {
        $('.js-typeA').fadeOut().find('textarea, input').prop('disabled', true);
        $('.js-typeB').fadeIn().find('textarea, input').prop('disabled', false);
        $('.js-typeC').fadeOut().find('textarea, input').prop('disabled', true);
        //雇用形態で「副業・業務委託」を選択
      } else if ($('.js-outsourcing').prop('checked')) {
        $('.js-typeA').fadeOut().find('textarea, input').prop('disabled', true);
        $('.js-typeB').fadeOut().find('textarea, input').prop('disabled', true);
        $('.js-typeC').fadeIn().find('textarea, input').prop('disabled', false);
        outsourcingSalaryChanger();
        //雇用形態で「新卒 or 中途／アルバイト・パート」を選択
      } else if ($('.js-full_time').prop('checked') || $('.js-part_time').prop('checked')) {
        $('.js-typeA').fadeIn().find('textarea, input').prop('disabled', false);
        $('.js-typeB').fadeOut().find('textarea, input').prop('disabled', true);
        $('.js-typeC').fadeOut().find('textarea, input').prop('disabled', true);
        //「オンライン開催」を強制的に「就業場所」の透明を解除する
        $('.js-workplace-edit').removeClass('nouse');
      }
    }
  }

  //【企業】副業・業務委託で、「その他」を選択したら「基本給」「給与の下限」「給与の上限」を非表示にし、disabledにする
  $('.js-salary-type input[type="radio"]').on('change', function () {
    outsourcingSalaryChanger();
  });

  function outsourcingSalaryChanger() {
    if ($('input.js-salary-other').prop('checked')) {
      $('.js-salary-input').fadeOut().find('input').prop('disabled', true);
      $('.js-salary-input').find('input').prop('disabled', true);
    } else {
      $('.js-salary-input').fadeIn().find('input').prop('disabled', false);
    }
  }

  //【企業】給与形態の選択状況によって表示を切り替える
  if ($('input[type="radio"][name="salary_type"]').length) {
    const salaryType = {
      monthly: '月給',
      daily: '日給',
      hourly: '時給',
      annual: '年俸',
      unpaid: '無給',
      other: 'その他',
    };
    // 副業・業務委託は「報酬」なので月額・日額と表記する
    const outsourcingSalaryType = {
      ...salaryType,
      monthly: '月額',
      daily: '日額',
    };
    salaryTypeChanger($('input[name="salary_type"]:checked').val());
    $($('input[name="salary_type"]')).on('change', function () {
      salaryTypeChanger($(this).val());
    });

    function salaryTypeChanger(type) {
      const itemName = salaryType[type];
      $('[data-linkage="salary_type"]').not('.js-typeC [data-linkage="salary_type"]').text(itemName);
      $('.js-typeC [data-linkage="salary_type"]').text(outsourcingSalaryType[type]);

      if (itemName === '月給' || itemName === '年俸') {
        $('.js-if-salary-type-monthly-or-anual').show();
      } else {
        $('.js-if-salary-type-monthly-or-anual').hide();
      }

      if (itemName === '無給') {
        $('.js-if-salary-type-unpaid').show();
        $('.js-unless-salary-type-unpaid').hide();
      } else {
        $('.js-if-salary-type-unpaid').hide();
        $('.js-unless-salary-type-unpaid').show();
      }

      if (itemName === 'その他') {
        $('.js-if-salary-type-other').show();
        $('.js-unless-salary-type-other').hide();
      } else {
        $('.js-if-salary-type-other').hide();
        $('.js-unless-salary-type-other').show();
      }
    }
  }

  //【企業】固定残業をあり／なしでその下の給与の備考の表示を切り替える
  if ($('input[type="radio"][name="overtime"]').length) {
    const template =
      '月給には固定残業代（月●時間分、●円分）を含みます。※超過分は時間外手当を支給します';
    const toggleSalaryField = () => {
      const isOvertime = JSON.parse($('input[type="radio"][name="overtime"]:checked').val());
      if (isOvertime) {
        if (!$('textarea[name="salary"]').val()) {
          $('textarea[name="salary"]').val(template);
        }
        $('[data-linkage="overtime"] .required-tag').text('必須');
        $('[data-linkage="overtime"] .required-tag').removeClass('-option');
        $('[data-linkage="overtime"] .required-tag').addClass('-must');
      } else {
        if ($('textarea[name="salary"]').val() === template) {
          $('textarea[name="salary"]').val('');
        }
        $('[data-linkage="overtime"] .required-tag').text('任意');
        $('[data-linkage="overtime"] .required-tag').removeClass('-must');
        $('[data-linkage="overtime"] .required-tag').addClass('-option');
      }
    };
    toggleSalaryField();

    $('input[type="radio"][name="overtime"]').on('change', function () {
      toggleSalaryField();
    });
  }

  //【企業】郵便番号から住所自動入力
  if ($('form input[name="zip_code"].js-autocomplete-address').length) {
    $('form input[name="zip_code"].js-autocomplete-address').on('input', function () {
      if ($(this).val().length === 7) {
        fetchZipCloud($(this).val()).then((data) => {
          if (data.status === 200) {
            const prefectureType = data.results[0].prefcode;
            const address = `${data.results[0].address2}${data.results[0].address3}`;
            $(this)
              .closest('form')
              .find('select[name="prefecture_type"]')
              .find(`option[value="${prefectureType}"]`)
              .prop('selected', true);
            $(this).closest('form').find('input[name="address"]').val(address);
          }
        });
      }
    });
  }

  /* 【企業】求人を行う業種・職種の選択モーダル
  -------------------------------*/
  if ($('.modalSearch').length) {
    //キーワード検索
    const searchWord = function () {
      var searchResult,
        searchText = $(this).val(), // 検索ボックスに入力された値
        targetText;
      // 検索ボックスに値が入ってる場合
      if (searchText != '') {
        $(this)
          .parents('.type-select-radio')
          .find('.box')
          .each(function () {
            searchResult = [];
            $(this)
              .find('label span')
              .each(function () {
                targetText = $(this).text();
                $(this).parents('li').show();
                // 検索対象となるリストに入力された文字列が存在するかどうかを判断
                if (targetText.toLowerCase().indexOf(searchText) != -1) {
                  // 存在する場合はそのリストのテキストを用意した配列に格納
                  searchResult.push(targetText);
                  $(this).show();
                } else {
                  $(this).parents('li').hide();
                }
              });
            if (searchResult.length == 0) {
              $(this).hide();
            } else {
              $(this).show();
            }
          });
      } else {
        // 検索ボックスに値が入ってない場合
        $('.type-select-radio li').show();
        $('.type-select-radio .box').show();
      }
    };
    $('.modalSearch-text').on('input', searchWord);

    //モーダルで選んだ選択肢を、閉じたあとにselectに代入する
    $('.type-select-radio input[type="radio"]').change(function () {
      var type = $(this).attr('name');
      var val = $(this).val();
      $('select[name="' + type + '"]').val(val);
      setTimeout(() => {
        $('.modal-wrap[data-modal="search-job"], .modal-wrap[data-modal="search-type"]').fadeOut(
          200
        );
      }, 200);
    });
    //selectを押したときに、モーダル内の選んだ選択肢にチェックを入れる
    $('.select-dum')
      .parents('.select')
      .on('click', function () {
        var val = $(this).children('select').val();
        $('.type-select-radio input[type="radio"][value="' + val + '"]').prop('checked', true);
      });
  }

  //【企業】サイドバー表示ハンバーガーメニュー
  $('.js-sidebarTrg').on('click', function () {
    $(this).toggleClass('act');
    $('.main-sidebar').toggleClass('act');
  });

  //【企業】横暴者のステータス変更時のフィードバックドフォーム
  if ($('#assessment-feedback-form').length) {
    $('#assessment-feedback-form').on('submit', function () {
      const validateRadio =
        !!$('#assessment-feedback-form input:radio:checked[name="precision"]').length ||
        !!$('#assessment-feedback-form input:radio:checked[name="usefulness"]').length;
      const validateText = !!$('#assessment-feedback-form textarea[name="message"]').val();
      if (validateRadio || validateText) {
        return true;
      } else {
        $('#assessment-feedback-form .error-txt').show();
        return false;
      }
    });
  }

  // 【企業】応募者管理一覧ページの求人絞り込み
  if ($('#c-applicant, #c-applicant-contact #recruit-select-form').length) {
    $('#recruit-select-form select').on('change', function () {
      $('#recruit-select-form').submit();
    });
    const selected = !!$('#recruit-select-form select').val();
    if (selected) {
      $('#recruit-select-form select').addClass('act');
    }
  }

  //【企業】ページ表示で印刷させる
  if ($('body#c-person-print, #c-directly-assessemt-result-print, #c-analysis-print').length) {
    window.print();
  }

// 【企業】テーブルの幅揃え
if ($('.dl-table-rspsv').length) {
  function dl_table_th() {
    $('.dl-table-rspsv').each(function () {
      var $table = $(this);
      var maxW = 0;
      // すべての dt 要素を検索し、最大幅を取得
      $table.find('dt').css('width', 'auto'); // 既存の幅をリセット
      $table.find('dt').each(function () {
        maxW = Math.max(maxW, $(this).width());
      });
      // 最大幅を取得後にすべての dt 要素に幅を設定
      $table.find('dt').width(maxW + 2);
    });
  }
  dl_table_th(); // 初期処理
  // モーダルの表示後に再調整
  $(document).on('click', '.modal-tgl', function () {
    setTimeout(dl_table_th, 100);
  });
}


  document.querySelectorAll('[data-cursor-trigger]').forEach((trigger) => {
    let item = document.querySelector(`[data-cursor-item="${trigger.dataset.cursorTrigger}"]`);
    trigger.addEventListener('mouseover', (e) => {
      item.style.display = 'block';
    });
    trigger.addEventListener('mouseout', (e) => {
      item.style.display = 'none';
    });
    trigger.addEventListener('mousemove', (e) => {
      item.style.left = `${e.clientX + 10}px`;
      item.style.top = `${e.clientY + 10}px`;
    });
  });

  if ($('#messages').length) {
    const input = document.getElementById('file-attach-field');
    let fileObjectList = [];

    input.addEventListener('change', () => {
      Array.from(input.files).forEach((fileObject) => {
        fileObjectList.push(fileObject);
      });
      const dataTransfer = new DataTransfer();
      fileObjectList.forEach((fileObject) => {
        dataTransfer.items.add(fileObject);
      });
      input.files = dataTransfer.files;
      $('.textarea-wrap .attachments').empty();
      fileObjectList.forEach((file) => {
        document
          .querySelector('.textarea-wrap .attachments')
          .insertAdjacentHTML(
            'beforeend',
            `<li class="file"><p>${file.name}</p><span class="delete-button" data-key="${file.lastModified}"></span></li>`
          );
      });
      console.log(fileObjectList);

      document
        .querySelectorAll('.textarea-wrap .attachments .file .delete-button')
        .forEach((node) => {
          node.addEventListener('click', (e) => {
            e.target.parentNode.remove();
            fileObjectList = fileObjectList.filter((item) => {
              return !(item.lastModified == e.target.dataset.key);
            });
            const dataTransfer = new DataTransfer();
            fileObjectList.forEach((fileObject) => {
              dataTransfer.items.add(fileObject);
            });
            input.files = dataTransfer.files;
            console.log(fileObjectList);
          });
        });
    });
  }

  if ($('.js-message-omission').length) {
    $('.js-message-omission').each(function () {
      if ($(this).height() > 112) {
        $(this).addClass('close');
        const toggle = $(this).siblings('.js-message-omission-toggle');
        toggle.show();
        toggle.on('click', function () {
          $(this).toggleClass('close');
          $(this).siblings('.js-message-omission').toggleClass('close');
        });
      }
    });
  }

  const toggles = document.getElementsByClassName('js-planListTable-toggleDetails-toggle');
  for (const toggle of toggles) {
    toggle.addEventListener('click', () => {
      for (const toggle of toggles) { toggle.classList.toggle('isActive') }
      for (const body of document.getElementsByClassName('js-planListTable-toggleDetails-body')) {
        $(body).slideToggle('fast');
      }
    });
  }

  if ($('#c-profile-company-edit .company-logo-field').length) {
    const d = document;
    const fileField = d.querySelector('input[name="company_logo"]');
    const imgPreview = d.querySelector('.company-logo-preview');
    const delButton = d.querySelector('.company-logo-delete');

    fileField.addEventListener('change', () => {
      imgPreview.src = URL.createObjectURL(fileField.files[0]);
      d.querySelector('.company-logo-field').classList.add('attached');
    });

    delButton.addEventListener('click', () => {
      fileField.value = '';
      d.querySelector('.company-logo-field').classList.remove('attached');
    });
  }

  if (document.getElementsByClassName('js-scoutPersonList').length) {
    const setUserCode = (...codeList) => {
      const mountTarget = document.querySelector('.js-scoutPersonList-codeMountTarget');
      if (!mountTarget) return;
      while (mountTarget.firstChild) { mountTarget.removeChild(mountTarget.firstChild) }
      codeList.forEach((code) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'user_code[]';
        input.value = code;
        mountTarget.append(input);
      });
    }

    const getNextUserList = (() => {
      let page = 1;
      return async () => {
        page++;
        const currentParams = new URLSearchParams(location.search);
        currentParams.set('page', page);
        const res = await fetch(`/company/ajax/scout/person/next?${currentParams.toString()}`);
        const html = await res.text();
        const hasNext = res.ok;
        return { html, hasNext };
      };
    })();

    const checkScoutable = async (count) => {
      const res = await fetch(`/company/scout/scoutable?count=${count}`);
      return await res.json();
    }

    for (const scoutPersonList of document.getElementsByClassName('js-scoutPersonList')) {
      const scoutCounter = document.getElementsByClassName('js-scoutPersonList-scoutCounter')[0];
      const scoutCounterNumber = scoutCounter.getElementsByClassName('js-scoutPersonList-scoutCounter-number')[0];
      scoutPersonList.addEventListener('click', (e) => {
        // お気に入りボタンをクリックした場合
        const favoriteCheckbox = e.target.closest('.js-scoutPersonList-favoriteCheckbox');
        if (favoriteCheckbox) {
          const user_id = favoriteCheckbox.dataset.userId;
          const recruit_id = favoriteCheckbox.dataset.recruitId;
          fetch('/company/ajax/company/favorite', {
            method: favoriteCheckbox.checked ? 'POST' : 'DELETE',
            credentials: 'same-origin',
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id, recruit_id }),
          }).then((res) => {
            if (!res.ok) {
              favoriteCheckbox.checked = !favoriteCheckbox.checked;
            }
          });
        }

        // スカウトのチェックボックスをクリックした場合
        if (e.target.closest('.js-scoutPersonList-scoutCheckbox')) {
          const checkedCount = scoutPersonList.querySelectorAll('.js-scoutPersonList-scoutCheckbox:checked').length;
          scoutCounterNumber.textContent = checkedCount;
          if (checkedCount !== 0) {
            scoutCounter.classList.add('isActive');
          } else {
            scoutCounter.classList.remove('isActive');
          }
        }

        // スカウトを送るボタンをクリックした場合
        const scoutButton = e.target.closest('.js-scoutPersonList-scoutButton');
        if (scoutButton) {
          const recruitSelected = scoutPersonList.dataset.recruitSelected == 'true';
          const scoutSelected = scoutPersonList.dataset.scoutSelected == 'true';
          if (scoutButton.dataset.type === 'single') {
            if (recruitSelected && scoutSelected) {
              checkScoutable(1).then((json) => {
                if (json.scoutable) {
                  setUserCode(scoutButton.value);
                  $('[data-modal="scoutModal-send"]').show();
                } else {
                  $('[data-modal="scoutModal-reachedLimit"]').show();
                }
              });
            }
          } else if (scoutButton.dataset.type === 'multiple') {
            const userCodeList = Array.from(scoutPersonList.querySelectorAll('.js-scoutPersonList-scoutCheckbox:checked')).map((elem) => {
              return elem.value;
            });
            if (recruitSelected && scoutSelected) {
              checkScoutable(userCodeList.length).then((json) => {
                if (json.scoutable) {
                  setUserCode(...userCodeList);
                  $('[data-modal="scoutModal-send"]').show();
                } else {
                  $('[data-modal="scoutModal-reachedLimit"]').show();
                }
              });
            }
          }
        }
      });

      const observeElement = document.getElementsByClassName('js-scoutPersonList-observationTarget')[0];
      if (observeElement) {
        const scrollObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(async (entry) => {
            if (entry.isIntersecting) {
              observeElement.classList.add('isActive');
              const { html, hasNext } = await getNextUserList();
              scoutPersonList.insertAdjacentHTML('beforeend', html);
              observeElement.classList.remove('isActive');
              observer.disconnect();
              if (hasNext) observer.observe(observeElement);
            }
          });
        }, {
          root: document,
          rootMargin: '600px 0px 600px 0px',
          threshold: 0,
        });
        scrollObserver.observe(observeElement);
      }
    }
  }

  // スカウト一覧 検索フォーム
  if (document.getElementsByClassName('js-scoutPersonForm').length) {
    const search = async (formData) => {
      const query = new URLSearchParams(formData).toString();
      const res = await fetch(`/company/ajax/scout/person?${query}`);
      if (res.ok) {
        return await res.json();
      }
    };

    const scoutPersonForm = document.querySelector('.js-scoutPersonForm');
    const currentConditionView = document.querySelector('.js-currentConditionView');
    const conditionList = currentConditionView.querySelectorAll('[data-condition]');
    const userCount = currentConditionView.querySelector('.js-companyScout-userCount');
    const clearFormButton = currentConditionView.querySelector('.js-companyScout-resetButton');
    let timeoutID;

    scoutPersonForm.addEventListener('change', (e) => {
      if (timeoutID) clearTimeout(timeoutID);
      const formData = new FormData(scoutPersonForm);
      timeoutID = setTimeout(async () => {
        const res = await search(formData);
        for (const v of conditionList) {
          v.textContent = res.current_condition[v.dataset.condition] ?? '(未指定)';
        }
        countingAnimation({
          start: 0,
          end: res.count,
          duration: 500,
          target: userCount,
        });
      }, 500);
    });

    clearFormButton.addEventListener('click', (e) => {
      for (const select of scoutPersonForm.querySelectorAll('select')) {
        select.selectedIndex = 0;
      }
      for (const checkbox of scoutPersonForm.querySelectorAll('input[type="checkbox"]:checked')) {
        checkbox.checked = false;
      }
      scoutPersonForm.dispatchEvent(new Event('change'));
    });
  }

  if (document.getElementsByClassName('js-companyScout-accordion').length) {
    for (const accordion of document.getElementsByClassName('js-companyScout-accordion')) {
      accordion.addEventListener('click', (e) => {
        e.stopPropagation();
        const toggle = e.target.closest('.js-companyScout-accordion-toggle');
        if (!toggle) return;
        const body = toggle.nextElementSibling;
        if (!body.classList.contains('js-companyScout-accordion-body')) return;

        $(body).slideToggle('fast');
        accordion.classList.toggle('isOpen');
      });
    }
  }

  if (!!document.getElementsByClassName('js-scoutTerm-monitorChangeEvent').length) {
    const patchScoutTerm = async (src, body) => {
      return await fetch(src, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
    };

    for (const monitorChangeEvent of document.getElementsByClassName('js-scoutTerm-monitorChangeEvent')) {
      monitorChangeEvent.addEventListener('change', async (e) => {
        const favoriteButton = e.target.closest('.js-scoutTerm-favoriteButton');
        const notifyButton = e.target.closest('.js-scoutTerm-notifyButton');

        if (favoriteButton) {
          const id = favoriteButton.value;
          const is_favorite = favoriteButton.checked;
          const res = await patchScoutTerm('/company/ajax/scout/term_list/favorite', { id, is_favorite });
          if (!res.ok) {
            favoriteButton.checked = !isChecked;
          }
        }

        if (notifyButton) {
          const id = notifyButton.value;
          const is_notify = notifyButton.checked;
          const res = await patchScoutTerm('/company/ajax/scout/term_list/notify', { id, is_notify });
          if (!res.ok) {
            notifyButton.checked = !isChecked;
          }
        }
      });
    }
  }
});

//--------------------------------------------------
/*
  turbolinks:load resize scroll
*/
$(window).on('turbolinks:load resize scroll', function () {
  //【企業】スクロールでコンタクト・スカウトCV出現
  if ($('.nav-entry').length) {
    var html_h = $('html').outerHeight();
    var adj_h = html_h - $(window).outerHeight();
    var scroll = $(this).scrollTop();
    if (adj_h > 100) {
      $('.nav-entry').css('transform', 'translateY(100%)');
      if (scroll > 100) {
        $('.nav-entry').css('transform', 'translateY(0)');
      } else {
        $('.nav-entry').css('transform', 'translateY(100%)');
      }
    } else {
      $('.nav-entry').css('transform', 'translateY(0)');
    }
  }
});

//--------------------------------------------------
/*
  turbolinks:load resize
*/
$(window).on('turbolinks:load resize', function () {
  //【共通】メッセージUI
  if ($('.send-block').length) {
    //メッセージ最下部に移動
    setTimeout(function () {
      window.scroll(0, $(document).height());
    }, 0);
    var w = $(window).width();
    var bp = 768;
    if (w > bp) {
      $('body').css('padding-bottom', '88px');
    } else if (w < bp) {
      $('body').css('padding-bottom', '55px');
    }
    $(function () {
      $('.send-block textarea').bind('keyup', function () {
        var body_h = $('.send-block').outerHeight();
        $('body').css('padding-bottom', body_h);
      });
    });
    // 1度のみ送信
    $(".send-block button[type='submit']").click(function () {
      if ($('.send-block textarea').val() !== '') {
        $(".send-block button[type='submit']").css('pointer-events', 'none');
      }
    });
  }

  // 【企業】サイドバーがあるか確認してあれば位置を調整
  if ($('body').find('.main-sidebar').length) {
    let target = 'main, #global-nav, .log-alert';
    $(target).addClass('js-has-sidebar');
  }

  //【企業】採用の流れチェックリスト
  if ($('#c-mypage').length) {
    const calcTranslate = () => {
      const wrapperWidth = $('.hiring-process-checklist').width();
      let movePixel = wrapperWidth / 2 - 78;
      const activeTabNumber = $('.checklist-tabs > .item.act').data('tab');
      if (activeTabNumber == 1) {
        movePixel;
      } else if (activeTabNumber === 2) {
        movePixel += -163;
      } else if (activeTabNumber === 3) {
        movePixel += -163 * 2;
      } else if (activeTabNumber === 4) {
        movePixel += -163 * 3;
      } else if (activeTabNumber === 5) {
        movePixel += -163 * 4;
      }
      $('.checklist-tabs').css('transform', `translateX(${movePixel}px)`);
    };
    const windowWidth = $(window).width();
    if (windowWidth < 767) {
      calcTranslate();
    } else {
      $('.checklist-tabs').css('transform', '');
    }
    $('.checklist-tabs > .item').on('click', function () {
      $('.checklist-tabs > .item').removeClass('act');
      $(this).addClass('act');
      const tabNumber = $(this).data('tab');
      $('.hiring-process-checklist .checklist-content').removeClass('act');
      $(`.checklist-content[data-tab=${tabNumber}]`).addClass('act');
      if (windowWidth < 767) {
        calcTranslate();
      }
    });
  }

  /* 【企業】ナビゲーション等の有無でbodyにpaddingを追加 */
  var w = $(window).width();
  var bp = 767;
  if ($('#global-nav').length) {
    if (w > bp) {
      $('body').css('padding-top', '0', 'padding-bottom', '0');
      $('#global-nav').removeClass('inherit');
      if ($('#global-nav ul').length) {
        $('body').css('padding-top', '60px');
      } else {
        $('body').css('padding-top', '45px');
      }
    } else {
      $('body').css('padding-top', '0', 'padding-bottom', '0');
      if (!$('#global-nav').hasClass('sm-d-n')) {
        if ($('#global-nav ul').length) {
        } else {
          $('#global-nav').addClass('inherit');
          $('body').css('padding-top', '45px');
        }
      }
    }
  }

  // 【企業】退会モーダル内の同意によって切り替える処理
  if ($('input[name="confirm_withdrawal"]').length) {
    $('input[name="confirm_withdrawal"]').on('change', function (e) {
      if (e.target.checked) {
        $('button[name="withdrawal_button"]').prop('disabled', false);
      } else {
        $('button[name="withdrawal_button"]').prop('disabled', true);
      }
    });
  }

  //【企業】領収書ページ
  $(window).on('turbolinks:load resize', function (e) {
    if ($('#c-agrement-invoice-receipt').length) {
      $(window).on('beforeprint', function () {
        $('.js-print-hide').hide();
        html2canvas(document.querySelector('.receipt')).then(function (canvas) {
          $('body').append(canvas);
          $('.receipt').hide();
        });
      });
      $(window).on('afterprint', function () {
        $('.js-print-hide').show();
        $('canvas').remove();
        $('.receipt').show();
      });
    }
  });

  //【企業】ステータスバーやスカウト・コンタクトボタンのUIの有無でpaddingを追加
  if ($('.status-bar').length && w < bp) {
    $('body').css('padding-top', '45px');
  }
  if ($('.nav-entry').length && w > bp) {
    $('body').css('padding-bottom', '65px');
  } else if ($('.nav-entry').length && w < bp) {
    $('body').css('padding-bottom', '75px');
  }

  //【企業】ボタン下にエラーをまとめて出すための記述
  if ($('.new-validate-btn').length) {
    $('.new-validate-btn').on('click', function (e) {
      $('[data-if-invalid]').hide();
      const invalidFields = $(this).parents('form').find(':invalid');
      if (0 < invalidFields.length) {
        e.preventDefault();
        invalidFields.each(function () {
          const name = $(this).attr('name');
          const message = $(this)[0].validationMessage;
          $(`[data-if-invalid="${name}"]`).show();
          $(`[data-invalid-message="${name}"]`).text(message);
        });
      }
    });
  }

    //【企業】「新しく募集を作成する」モーダル内：チェックボックスによって入力欄を表示/非表示
    if ($('.js-form-toggle-trigger').length) {
      // ラジオボタンの変更イベント
      $(".js-form-toggle-trigger").on("change", function() {
        let $radio = $(this);
        let name = $radio.attr("name"); // ラジオボタンの name を取得
        let value = $radio.is(":checked") ? $radio.val() : null; // ラジオボタンの value を取得
        let $form = $radio.closest("form");

        // 全ての .js-form-toggle-content を即座に非表示 & 内部の input, select, textarea, button を無効化
        $form.find(`.js-form-toggle-content[data-name="${name}"]`).each(function() {
          let $content = $(this);
          $content.css("display", "none"); // 即座に非表示
          $content.find("input, select, textarea, button").prop("disabled", true);
        });

        // 選択された value に該当する .js-form-toggle-content をフェードイン & 入力を有効化
        let $targetContent = $form.find(`.js-form-toggle-content[data-name="${name}"][data-value="${value}"]`);
        if ($targetContent.length) {
          $targetContent.find("input, select, textarea, button").prop("disabled", false);
          $targetContent.fadeIn(200);
        }
      });
      // 初期状態の適用（ページ読み込み時に現在の選択状態を反映）
      $(".js-form-toggle-trigger:checked").trigger("change");
    }


});
